import { render, staticRenderFns } from "./winlossuser-new.vue?vue&type=template&id=2137593e&scoped=true&"
import script from "./winlossuser-new.vue?vue&type=script&lang=js&"
export * from "./winlossuser-new.vue?vue&type=script&lang=js&"
import style0 from "./winlossuser-new.vue?vue&type=style&index=0&id=2137593e&scoped=true&lang=css&"
import style1 from "./winlossuser-new.vue?vue&type=style&index=1&id=2137593e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137593e",
  null
  
)

export default component.exports